import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetTariffsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tariffs/models/inputs/get-tariffs-paginated.form-validation';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tariffs/models/inputs/get-tariffs-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { TariffTypeFilterController } from '../../tariff-type-filter/tariff-type-filter.controller';

const TariffListFilterFormStep1TypeFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetTariffsPaginatedModel>();
  const { type } = useGetTariffsPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.L} flex={1} direction="column">
      <Controller
        name="type"
        control={control}
        rules={type}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <TariffTypeFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
    </Stack>
  );
};

export const TariffListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.XL}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.XL}>
        <TariffListFilterFormStep1TypeFragment />
      </Stack>
    </Stack>
  );
};
